/**
 * threat.ts — ONE danger feed for the score (2026-09-20). PURE (a clock is passed in).
 *
 * The combat music knew two dangers: space combat and an aggro creature. A PvP
 * duel, an arena round, a bounty hunter that had COMMITTED to the kill and a
 * ground battle you were standing in all played under exploration silence.
 * Systems that know a danger REPORT it here with a short lease; the music asks
 * one question. A lease that is not renewed simply lapses — a system torn down
 * mid-fight can never leave the combat loop running.
 *
 * FAIRNESS: only OVERT danger may be reported. A hunter that is merely near, or
 * still stalking unseen, must never start a soundtrack that gives it away —
 * evidence comes from the world, not from the score. (The hunter reports only
 * at `commit` / `engage`, which the game already announces with a clear tell.)
 */
export type ThreatKind = 'pvp' | 'hunter' | 'battle' | 'airwar';

interface Lease { untilMs: number }
interface Registry { leases: Map<ThreatKind, Lease> }
const store = globalThis as unknown as { __atlasThreat?: Registry };
const reg = (): Registry => (store.__atlasThreat ??= { leases: new Map() });

/** Default lease: a little over two music ticks (the music polls once a second). */
export const THREAT_LEASE_MS = 2500;

export function reportThreat(kind: ThreatKind, nowMs: number, leaseMs = THREAT_LEASE_MS): void {
  reg().leases.set(kind, { untilMs: nowMs + leaseMs });
}
export function clearThreat(kind: ThreatKind): void { reg().leases.delete(kind); }

/** The dangers live right now (expired leases are dropped as they are found). */
export function activeThreats(nowMs: number): ThreatKind[] {
  const out: ThreatKind[] = [];
  for (const [k, l] of reg().leases) { if (l.untilMs > nowMs) out.push(k); else reg().leases.delete(k); }
  return out;
}
